import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useAuth } from '~/composables/useAuth'

export default defineNuxtRouteMiddleware(async () => {
    const {
        getAccessToken,
        getTokenData,
        refreshAccessToken,
        isLoggedIn,
        logout
    } = useAuth()

    const token = getAccessToken()

    if (!token) {
        const newToken = await refreshAccessToken()
        if (!newToken) { return navigateTo('/login') }
        return
    }

    let payload
    try {
        payload = getTokenData()
    } catch (e) {
        const newToken = await refreshAccessToken()
        if (!newToken) {
            return navigateTo('/login')
        }
        return
    }

    const now = Math.floor(Date.now() / 1000)
    const isExpired = !payload?.exp || payload.exp < now
    if (isExpired) {
        const newToken = await refreshAccessToken()
        if (!newToken) {
            console.error('[Auth] Refresh gagal, logout user...')
            await logout()
            return navigateTo('/login')
        }
        return
    }

    if (!isLoggedIn.value) {
        const newToken = await refreshAccessToken()
        if (!newToken) {
            await logout()
            return navigateTo('/login')
        }
        return
    }
})
